export const SETTINGS_OPTION = [ 'click-and-confirm', 'trading-quantities' ] as const;
export type ESettingsOption = typeof SETTINGS_OPTION[number];
